<div class="date-range-input" [ngClass]="variantClass">
  <p *ngIf="label" [id]="id" class="date-range-input__label">
    {{ label }}
  </p>

  <button
    [attr.aria-label]="!label && ariaLabel"
    [attr.aria-labelledby]="label && id"
    [attr.aria-valuenow]="getFormattedDateRange()"
    class="date-range-input__button"
    [class.date-range-input__button--has-value]="getFormattedDateRange()"
    type="button"
    (click)="dateRangeModal.show()"
  >
    <vtmn-play-icon
      class="date-range-input__icon"
      [name]="icon?.Calendar"
    ></vtmn-play-icon>

    {{ dateRangeButtonText }}
  </button>

  <button type="button" *ngIf="getFormattedDateRange()">
    <vtmn-play-icon
      ariaLabel="'a11y.attendee.date_range.button.clear' | translate"
      class="date-range-input__right-icon"
      [name]="icon?.Close"
      (click)="clear()"
    ></vtmn-play-icon>
  </button>

  <app-modal
    class="date-range-modal"
    [modalVariant]="modalVariant.Spaced"
    (modalClose)="closeModal()"
  >
    <span modal-header class="title-5 text-center">
      {{ 'attendee.date_range.modal.title' | translate }}
    </span>

    <form [formGroup]="dateRangeForm" modal-content class="text-left">
      <app-form-input-group
        class="block mb-3"
        [label]="'attendee.date_range.modal.input.from.label' | translate"
        [errors]="from?.touched && from?.errors"
        errorKey="from_date"
      >
        <app-form-input
          #content
          formControlName="from"
          type="date"
          [placeholder]="
            'attendee.date_range.modal.input.from.placeholder' | translate
          "
          [min]="fromMinDate"
          [required]="true"
        >
        </app-form-input>
      </app-form-input-group>

      <app-form-input-group
        class="block mb-3"
        [label]="'attendee.date_range.modal.input.to.label' | translate"
      >
        <app-form-input
          #content
          formControlName="to"
          type="date"
          [placeholder]="
            'attendee.date_range.modal.input.to.placeholder' | translate
          "
          [min]="toMinDate"
        >
        </app-form-input>
      </app-form-input-group>
    </form>

    <div modal-footer class="flex justify-center items-center">
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.TERTIARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="clear()"
      >
        {{ 'attendee.date_range.modal.button.clear' | translate }}
      </button>

      <button
        app-vtmn-play-button
        type="submit"
        [type]="ctaButtonType.Submit"
        [disabled]="dateRangeForm.invalid ? true : null"
        [attr.data-disabled]="dateRangeForm.invalid ? true : null"
        [shape]="vtmnPlayButtonShape.SQUARED"
        class="ml-2"
        (click)="onSubmit()"
      >
        {{ 'attendee.date_range.modal.button.search' | translate }}
      </button>
    </div>
  </app-modal>
</div>
